<template>
  <div class="row center-block">
    <!--<h2>Data tables</h2>-->
    <div class="col-md-12">
      <div class="">
        <!--<div class="box-header">-->
        <!--<h3 class="box-title">品牌排程列表</h3>-->
        <!--</div>-->
        <!-- /.box-header -->
        <div class="box-body">
          <div class="row form-inline m-b-10">
            <div class="col-sm-6 text-left">
              <div class="from-group inline-block pull-left">
                <div class="btn btn-default btn-table-title h-38" @click="reportPromotion">產生報表</div>
              </div>
              <div class="inline-block from-group pull-left m-l-5" v-if="storeBrief.length > 1" style="width: auto; min-width: 150px;">
                <multiselect
                        v-model="storeSelect"
                        :options="newStoreBrief"
                        label="label"
                        :searchable="false"
                        :allow-empty="false"
                        :close-on-select="true"
                        placeholder="門市"
                        :show-labels="false"
                        :preselect-first="true"
                        @input="changeSelect"
                >
                </multiselect>
              </div>
            </div>
            <div class="col-sm-6 text-right">
              <div class="form-group input-group time-box pull-right">
                <date-time-picker :date="menuTime.start" :option="dateoption" :limit="startLimit"></date-time-picker>
                <date-time-picker :date="menuTime.end" :option="dateoption" :limit="endLimit"></date-time-picker>
                <!--<input type="text" class="form-control time-picker" id="start-box" placeholder="起始時間">-->
                <!--<input type="text" class="form-control time-picker" id="end-box" placeholder="結束時間">-->
                <span class="input-group-btn">
                      <button class="btn btn-default submit-btn btn-search" type="button"
                              id="search" style="height: 72px" @click="search(1)">
                        <i class="fa fa-search"></i>
                      </button>
                    </span>
              </div>
            </div>
          </div>
          <div class="col-xs-12">
            <div class="row">
              <div class="box-body col-xs-12 text-center">
                <div class="col-xs-4">
                  <button class="btn-all bg-primary btn-detail-edit p-10" :class="{'active': typeSelect !== 1}" @click="typeSelect = 1">
                    累積
                  </button>
                </div>
                <div class="col-xs-4">
                  <button class="btn-basic bg-primary btn-detail-edit p-10" :class="{'active': typeSelect !== 2}" @click="typeSelect = 2">
                    期間
                  </button>
                </div>
                <div class="col-xs-4">
                  <button class="btn-gb bg-primary btn-detail-edit p-10" :class="{'active': typeSelect !== 3}" @click="typeSelect = 3">
                    目前
                  </button>
                </div>
                <!-- /.box-body -->
              </div>
            </div>
          </div>
          <div class="col-sm-12 table-responsive p-x-0">
            <table aria-describedby="example1_info" role="grid" id="example2" class="table table-bordered table-striped dataTable">
              <thead class="middle">
              <tr role="row">
                <th colspan="1" rowspan="2" aria-controls="example1" tabindex="0" class="">#</th>
                <th colspan="1" rowspan="2" aria-controls="example1" tabindex="0" class="" style="width: 320px">優惠券</th>
                <th colspan="1" rowspan="2" aria-controls="example1" tabindex="0" class="">門市</th>
                <th colspan="3" rowspan="1" aria-controls="example1" tabindex="0" class="" v-if="typeSelect !== 3">贈送</th>
                <th colspan="3" rowspan="1" aria-controls="example1" tabindex="0" class="" v-if="typeSelect !== 3">已折</th>
                <th colspan="3" rowspan="1" aria-controls="example1" tabindex="0" class="" v-if="typeSelect !== 3">折抵中</th>
                <th colspan="3" rowspan="1" aria-controls="example1" tabindex="0" class="" v-if="typeSelect !== 3">作廢</th>
                <th colspan="2" rowspan="1" aria-controls="example1" tabindex="0" class="" v-if="typeSelect === 3">有效</th>
                <th colspan="2" rowspan="1" aria-controls="example1" tabindex="0" class="" v-if="typeSelect === 3">逾期</th>
              </tr>
              <tr role="row">
                <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="c-pointer" v-if="typeSelect !== 3" @click="checkSort('give_order_amount')">訂單
                  <span v-if="sortMethod === 'give_order_amount'">
                      <i class="fa fa-caret-up" aria-hidden="true" v-if="sortToggle"></i>
                      <i class="fa fa-caret-down" aria-hidden="true" v-else></i>
                    </span>
                  <span v-else>
                      <i class="fa fa-sort" aria-hidden="true"></i>
                    </span>
                </th>
                <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="c-pointer" v-if="typeSelect !== 3" @click="checkSort('give_coupon_amount')">張數
                  <span v-if="sortMethod === 'give_coupon_amount'">
                      <i class="fa fa-caret-up" aria-hidden="true" v-if="sortToggle"></i>
                      <i class="fa fa-caret-down" aria-hidden="true" v-else></i>
                    </span>
                  <span v-else>
                      <i class="fa fa-sort" aria-hidden="true"></i>
                    </span>
                </th>
                <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" v-if="typeSelect !== 3">金額</th>
                <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="c-pointer" v-if="typeSelect !== 3" @click="checkSort('used_order_amount')">訂單
                  <span v-if="sortMethod === 'used_order_amount'">
                      <i class="fa fa-caret-up" aria-hidden="true" v-if="sortToggle"></i>
                      <i class="fa fa-caret-down" aria-hidden="true" v-else></i>
                    </span>
                  <span v-else>
                      <i class="fa fa-sort" aria-hidden="true"></i>
                    </span>
                </th>
                <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="c-pointer" v-if="typeSelect !== 3" @click="checkSort('used_coupon_amount')">張數
                  <span v-if="sortMethod === 'used_coupon_amount'">
                      <i class="fa fa-caret-up" aria-hidden="true" v-if="sortToggle"></i>
                      <i class="fa fa-caret-down" aria-hidden="true" v-else></i>
                    </span>
                  <span v-else>
                      <i class="fa fa-sort" aria-hidden="true"></i>
                    </span>
                </th>
                <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" v-if="typeSelect !== 3">金額</th>
                <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="c-pointer" v-if="typeSelect !== 3" @click="checkSort('using_order_amount')">訂單
                  <span v-if="sortMethod === 'using_order_amount'">
                      <i class="fa fa-caret-up" aria-hidden="true" v-if="sortToggle"></i>
                      <i class="fa fa-caret-down" aria-hidden="true" v-else></i>
                    </span>
                  <span v-else>
                      <i class="fa fa-sort" aria-hidden="true"></i>
                    </span>
                </th>
                <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="c-pointer" v-if="typeSelect !== 3" @click="checkSort('using_coupon_amount')">張數
                  <span v-if="sortMethod === 'using_coupon_amount'">
                      <i class="fa fa-caret-up" aria-hidden="true" v-if="sortToggle"></i>
                      <i class="fa fa-caret-down" aria-hidden="true" v-else></i>
                    </span>
                  <span v-else>
                      <i class="fa fa-sort" aria-hidden="true"></i>
                    </span>
                </th>
                <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" v-if="typeSelect !== 3">金額</th>
                <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="c-pointer" v-if="typeSelect !== 3" @click="checkSort('void_order_amount')">訂單
                  <span v-if="sortMethod === 'void_order_amount'">
                      <i class="fa fa-caret-up" aria-hidden="true" v-if="sortToggle"></i>
                      <i class="fa fa-caret-down" aria-hidden="true" v-else></i>
                    </span>
                  <span v-else>
                      <i class="fa fa-sort" aria-hidden="true"></i>
                    </span>
                </th>
                <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="c-pointer" v-if="typeSelect !== 3" @click="checkSort('void_coupon_amount')">張數
                  <span v-if="sortMethod === 'void_coupon_amount'">
                      <i class="fa fa-caret-up" aria-hidden="true" v-if="sortToggle"></i>
                      <i class="fa fa-caret-down" aria-hidden="true" v-else></i>
                    </span>
                  <span v-else>
                      <i class="fa fa-sort" aria-hidden="true"></i>
                    </span>
                </th>
                <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" v-if="typeSelect !== 3">金額</th>
                <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="c-pointer" v-if="typeSelect === 3" @click="checkSort('valid_coupon_amount')">張數
                  <span v-if="sortMethod === 'valid_coupon_amount'">
                      <i class="fa fa-caret-up" aria-hidden="true" v-if="sortToggle"></i>
                      <i class="fa fa-caret-down" aria-hidden="true" v-else></i>
                    </span>
                  <span v-else>
                      <i class="fa fa-sort" aria-hidden="true"></i>
                    </span>
                </th>
                <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" v-if="typeSelect === 3">金額</th>
                <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="c-pointer" v-if="typeSelect === 3" @click="checkSort('exp_coupon_amount')">張數
                  <span v-if="sortMethod === 'exp_coupon_amount'">
                      <i class="fa fa-caret-up" aria-hidden="true" v-if="sortToggle"></i>
                      <i class="fa fa-caret-down" aria-hidden="true" v-else></i>
                    </span>
                  <span v-else>
                      <i class="fa fa-sort" aria-hidden="true"></i>
                    </span>
                </th>
                <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" v-if="typeSelect === 3">金額</th>
              </tr>
              </thead>
              <tbody class="middle">
              <tr class="even" role="row" v-for="(coupon, index) in storeCouponList">
                <td class="sorting_1">{{index + 1}}</td>
                <td>
                  <div class="col-xs-12" style="padding: 10px 15px; background: #efefef; border-radius: 6px; min-width: 320px;">
                    <div class="coupon-left">
                      <h4>{{coupon.coupon_set_name}}</h4>
                      <p>{{coupon.coupon_set_description}}</p>
                    </div>
                    <div class="coupon-right">
                      <p class="v-middle" v-if="coupon.discount_type === 1">
                        $ {{coupon.discount_value}}
                      </p>
                      <p class="v-middle" v-if="coupon.discount_type === 2">
                        {{(100 - coupon.discount_value)/10}} 折
                      </p>
                    </div>
                  </div>
                </td>
                <td>{{coupon.store_name}} ({{coupon.store_id}})</td>
                <td class="td-success" v-if="typeSelect !== 3">
                  <span v-if="typeSelect === 1">{{coupon.give_order_amount}}</span>
                  <span v-else-if="typeSelect === 2">{{coupon.give_order_amount_seg}}</span>
                </td>
                <td class="td-success" v-if="typeSelect !== 3">
                  <span v-if="typeSelect === 1">{{coupon.give_coupon_amount}}</span>
                  <span v-else-if="typeSelect === 2">{{coupon.give_coupon_amount_seg}}</span>
                </td>
                <td class="td-success" v-if="typeSelect !== 3">
                  <span v-if="typeSelect === 1">$ {{coupon.give_coupon_money}}</span>
                  <span v-else-if="typeSelect === 2">$ {{coupon.give_coupon_money_seg}}</span>
                </td>
                <td class="td-warning" v-if="typeSelect !== 3">
                  <span v-if="typeSelect === 1">{{coupon.used_order_amount}}</span>
                  <span v-else-if="typeSelect === 2">{{coupon.used_order_amount_seg}}</span>
                </td>
                <td class="td-warning" v-if="typeSelect !== 3">
                  <span v-if="typeSelect === 1">{{coupon.used_coupon_amount}}</span>
                  <span v-else-if="typeSelect === 2">{{coupon.used_coupon_amount_seg}}</span>
                </td>
                <td class="td-warning" v-if="typeSelect !== 3">
                  <span v-if="typeSelect === 1">$ {{coupon.used_coupon_money}}</span>
                  <span v-else-if="typeSelect === 2">$ {{coupon.used_coupon_money_seg}}</span>
                </td>
                <td class="td-primary" v-if="typeSelect !== 3">
                  <span v-if="typeSelect === 1">{{coupon.using_order_amount}}</span>
                  <span v-else-if="typeSelect === 2">{{coupon.using_order_amount_seg}}</span>
                </td>
                <td class="td-primary" v-if="typeSelect !== 3">
                  <span v-if="typeSelect === 1">{{coupon.using_coupon_amount}}</span>
                  <span v-else-if="typeSelect === 2">{{coupon.using_coupon_amount_seg}}</span>
                </td>
                <td class="td-primary" v-if="typeSelect !== 3">
                  <span v-if="typeSelect === 1">$ {{coupon.using_coupon_money}}</span>
                  <span v-else-if="typeSelect === 2">$ {{coupon.using_coupon_money_seg}}</span>
                </td>
                <td class="td-danger" v-if="typeSelect !== 3">
                  <span v-if="typeSelect === 1">{{coupon.void_order_amount}}</span>
                  <span v-else-if="typeSelect === 2">{{coupon.void_order_amount_seg}}</span>
                </td>
                <td class="td-danger" v-if="typeSelect !== 3">
                  <span v-if="typeSelect === 1">{{coupon.void_coupon_amount}}</span>
                  <span v-else-if="typeSelect === 2">{{coupon.void_coupon_amount_seg}}</span>
                </td>
                <td class="td-danger" v-if="typeSelect !== 3">
                  <span v-if="typeSelect === 1">$ {{coupon.void_coupon_money}}</span>
                  <span v-else-if="typeSelect === 2">$ {{coupon.void_coupon_money_seg}}</span>
                </td>
                <td class="td-success" v-if="typeSelect === 3">
                  {{coupon.valid_coupon_amount}}
                </td>
                <td class="td-success" v-if="typeSelect === 3">
                  $ {{coupon.valid_coupon_money}}
                </td>
                <td class="td-danger" v-if="typeSelect === 3">
                  {{coupon.exp_coupon_amount}}
                </td>
                <td class="td-danger" v-if="typeSelect === 3">
                  $ {{coupon.exp_coupon_money}}
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="col-xs-12 text-center">
            <ul class="pagination">
              <li class="paginate_button" @click="clickEnd('pre')">
                <a class="c-pointer"><i class="fa fa-step-backward" aria-hidden="true"></i></a>
              </li>
              <li class="paginate_button"  @click="clickGroup('left')">
                <a class="c-pointer"><i class="fa fa-backward" aria-hidden="true"></i></a>
              </li>
              <li class="paginate_button" v-for="index in pageAmount" :class="{active: isActive(index)}" @click="clickPage(index)" v-if="pageShow(index)">
                <a class="c-pointer">{{index}}</a>
              </li>
              <li class="paginate_button disabled" v-for="dis in (groupAmount - Math.ceil(pageAmount % 10))" v-if="pageGroup === Math.ceil(pageAmount / groupAmount)">
                <a class="c-pointer">&nbsp;&nbsp;</a>
              </li>
              <li class="paginate_button" @click="clickGroup('right')">
                <a class="c-pointer"><i class="fa fa-forward" aria-hidden="true"></i></a>
              </li>
              <li class="paginate_button" @click="clickEnd('forward')">
                <a class="c-pointer"><i class="fa fa-step-forward" aria-hidden="true"></i></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Require needed datatables modules
import Multiselect from 'vue-multiselect'
import matcherModal from '../../../elements/Modal.vue'
import moment from 'moment'
import { mapGetters } from 'vuex'
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'

export default {
  components: {
    Multiselect,
    'm-modal': matcherModal,
    'date-time-picker': datetimePicker
  },
  props: {
    storeBrief: Array,
    getStoreName: Function
  },
  data () {
    return {
      searchStoreId: '',
      chartMethod: 1, // 1 = 菜單 ， 2 = 各店
      menuState: 4,
      name: '迷客夏',
      total: 1,
      count: 10,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      // new
      brandBrief: [],
      brandSelect: {label: '== 所有品牌 ==', value: 0},
      storeSelect: {label: '== 所有門市 ==', value: 0},
      ownerTypeSelect: {label: '== 舉辦者類型 ==', value: 99},
      ownerTypeList: [],
      statusSelect: {label: '== 行銷狀態 ==', value: 99},
      timeMethodSelect: {label: '== 行銷時間狀態 ==', value: 99},
      timeMethodList: [
        {label: '== 行銷時間狀態 ==', value: 99},
        {label: '未開始', value: 'notyet'},
        {label: '進行中', value: 'going'},
        {label: '已結束', value: 'end'}
      ],
      promotionList: [],
      curStoreId: '',
      ownerId: '',
      storeCouponList: [],
      curMarketingId: '',
      curActivityId: '',
      // date
      menuTime: {
        start: {
          time: moment().format('YYYY-MM-DD')
        },
        end: {
          time: moment().format('YYYY-MM-DD')
        }
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      startLimit: [
        {
          type: 'fromto',
          to: moment().add(1, 'days').format('YYYY-MM-DD')
        }
      ],
      endLimit: [
        {
          type: 'fromto',
          to: moment().add(1, 'days').add(1, 'days').format('YYYY-MM-DD')
        }
      ],
      typeSelect: 1,
      // sort
      sortMethod: '',
      sortToggle: false,
      preSortMethod: []
    }
  },
  mounted () {
    this.$nextTick(() => {
      // console.log(('#select-brand option').text().length)
    })
  },
  methods: {
    reportPromotion () {
      this.reportCouponChart()
    },
    checkSort (method) {
      this.sortMethod = method
      if (this.preSortMethod.length) {
        if (method === this.preSortMethod[0]) this.sortToggle = !this.sortToggle
        else {
          this.tableIndex = 1
          this.sortToggle = false
        }
        this.preSortMethod.splice(0, 1)
      } else this.sortToggle = false
      this.preSortMethod.push(method)
      this.clickPage(1)
    },
    setMarketing (marketingId) {
      this.curMarketingId = marketingId
    },
    setActivity (activityId) {
      this.curActivityId = activityId
    },
    search () {
      this.typeSelect = 2
      this.clickPage(1)
    },
    getItemType (type) {
      switch (type) {
        case 10: return '消費贈送活動'
        case 11: return '會員註冊贈送活動'
        case 20: return '代碼兌換活動'
        case 99: return '後台發送'
      }
    },
    ownerTypeName (type) {
      switch (type) {
        case 1: return '平台'
        case 2: return '品牌'
        case 3: return '門市'
      }
    },
    changeSelect (input) {
      if (typeof input.value !== 'undefined') {
        this.clickPage(1)
      }
    },
    clickGroup (type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1
        this.tableIndex = this.groupAmount * this.pageGroup
        this.clickPage(this.tableIndex)
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1
        this.clickPage(this.tableIndex)
      }
    },
    clickEnd (type) {
      if (type === 'pre') {
        this.clickPage(1)
        this.pageGroup = 1
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount)
        else this.clickPage(1)
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount)
      }
    },
    getTime (time) {
      if (time) {
        return moment(time, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm')
      }
    },
    trigger (event) {
      if (event === 'delMarketing') {
        this.delMarketing()
      } else if (event === 'delActivity') {
        this.delActivity()
      }
    },
    delMarketing () {
      var self = this
      var url = '/promotion/' + this.curMarketingId
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '提醒',
            text: '刪除行銷成功',
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.getCouponChart()
        }
      })
    },
    delActivity () {

    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    clickPage (index) {
      if (index) this.tableIndex = index
      this.getOrderCouponStoreUse()
    },
    pageShow (index) {
      var num = index / this.groupAmount
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true
      else return false
    },
    getOrderCouponStoreUse (page) {
      var self = this
      if (page) {
        this.tableIndex = page
        if (page === 1) this.pageGroup = 1
      }
      var url = '/statistic/activityOrderCouponStoreUse?'
      var roleType = this.roleType
      var data = {
        activity_id: this.$route.params.activity_id,
        page: this.tableIndex,
        size: this.count,
        start_date: moment(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_date: moment(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      }
      // store_id
      if (this.storeSelect.value) {
        if ((roleType === 99 || roleType === 30) && this.storeSelect.value !== 0) data.store_id = this.storeSelect.value
        else if (roleType === 10) data.store_id = this.storeSelect.value
      }
      for (var key in data) {
        url = url + key + '=' + data[key] + '&'
      }
      url = url.slice(0, -1)
      // sort
      if (this.sortMethod) {
        var newMethod = this.sortMethod
        if (this.typeSelect === 2) newMethod = newMethod + '_seg'
        url = url + '&list_sort=' + newMethod + ' '
        if (this.sortToggle) url = url + 'ASC'
        else url = url + 'DESC'
      }
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.storeCouponList = response.data.list
          self.total = response.data.list_total
        }
      })
    },
    reportCouponChart () {
      var url = '/statistic/activityOrderCouponStoreUseSheets?'
      var roleType = this.roleType
      var data = {
        activity_id: this.$route.params.activity_id,
        start_date: moment(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_date: moment(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      }
      // store_id
      if (this.storeSelect.value) {
        if ((roleType === 99 || roleType === 30) && this.storeSelect.value !== 0) data.store_id = this.storeSelect.value
        else if (roleType === 10) data.store_id = this.storeSelect.value
      }
      for (var key in data) {
        url = url + key + '=' + data[key] + '&'
      }
      url = url.slice(0, -1)
      // sort
      if (this.sortMethod) {
        var newMethod = this.sortMethod
        if (this.typeSelect === 2) newMethod = newMethod + '_seg'
        url = url + '&list_sort=' + newMethod + ' '
        if (this.sortToggle) url = url + 'ASC'
        else url = url + 'DESC'
      }
      this.getFile('get', url, null, function (response) {
        const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/vnd.ms-excel'}))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', '消費贈送優惠券統計表_' + moment().format('YYYY_MM_DD') + '.xlsx')
        document.body.appendChild(link)
        link.click()
      })
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    newStoreBrief () {
      var allStore = this.storeBrief
      allStore.splice(0, 0, {label: '== 所有門市 ==', value: 0})
      return allStore
    },
    statusList () {
      if (this.chartMethod === 2) {
        return [
          {label: '== 活動狀態 ==', value: 99},
          {label: '初始化', value: 0},
          {label: '編輯中', value: 1},
          {label: '待上架', value: 3},
          {label: '已上架', value: 4},
          {label: '已下架', value: 5}
        ]
      } else {
        return [
          {label: '== 行銷狀態 ==', value: 99},
          {label: '未發佈', value: 0},
          {label: '已發佈', value: 4},
          {label: '已下架', value: 9}
        ]
      }
    },
    getFile () {
      return this.$parent.getFile
    },
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    },
    searchPlaceholder () {
      var value = this.ownerTypeSelect.value
      switch (value) {
        case 99:
        case 1:
          return '不用填入'
        case 2:
          return '請填入品牌id'
        case 3:
          return '請填入門市id'
      }
    }
  },
  watch: {
    typeSelect () {
      this.sortMethod = ''
      this.sortToggle = false
      this.clickPage()
    },
    menuState () {
      this.tableIndex = 1
      this.pageGroup = 1
    },
    chartMethod () {
      this.sortMethod = ''
      this.sortToggle = false
      this.sortMethod = ''
      this.tableIndex = 1
      this.pageGroup = 1
      this.clickPage(1)
      window.sessionStorage.setItem('Nidin_coupon_chart', this.chartMethod)
    },
    'menuTime.end.time' () {
      var lastDay = moment(this.menuTime.end.time, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
      if (this.menuTime.start.time > lastDay) this.menuTime.start.time = lastDay
      this.startLimit = [
        {
          type: 'fromto',
          to: lastDay
        }
      ]
    },
    'menuTime.start.time' () {
      var lastDay = moment(this.menuTime.start.time).add('90', 'days')
      if (lastDay < moment()) this.menuTime.end.time = lastDay.format('YYYY-MM-DD')
      else this.menuTime.end.time = moment().format('YYYY-MM-DD')
      this.endLimit = [
        {
          type: 'fromto',
          from: moment(this.menuTime.start.time).subtract(1, 'days'),
          to: moment(this.menuTime.end.time).add(1, 'days')
        }
      ]
    }
  },
  created () {
    this.roleType = parseInt(this.getRoleType, 10)
    var sMethod = window.sessionStorage.getItem('Nidin_coupon_chart')
    if (sMethod) this.chartMethod = parseInt(sMethod, 10)
    // 設定當月第一天
    // this.menuTime.start.time = moment().format('YYYY-MM-01')
    this.getOrderCouponStoreUse()
  }
}
</script>
<style lang="sass">
  .td-danger
    background: #f8d7da
  .td-warning
    background: #fff3cd
  .td-primary
    background: #cce5ff
  .td-success
    background: #c3e6cb
  .table>thead>tr>th
    padding: 8px !important
  thead.middle tr th
    vertical-align: middle
    text-align: center
  tbody.middle tr td
    vertical-align: middle
    text-align: center
    font-weight: 600
    .coupon-left
      text-align: left
  .gantt
    border: 2px solid #ddd
  .menu-info
    min-height: 120px
    width: 100%
    text-align: center
    *
      padding: 0
      margin: 0
      line-height: 25px
  .m-b-15
    margin-bottom: 15px !important
  .btn-edit-all, .btn-del-all
    margin-right: 15px
    z-index: 100
  .nav-page-back, .page-number, .nav-page-next, .nav-zoomIn, .nav-zoomOut
    display: none !important
  .fn-gantt .leftPanel
    width: 100px !important
  .fn-gantt .leftPanel .fn-wide, .fn-gantt .leftPanel .fn-wide .fn-label
    font-size: 14px
  .fn-gantt .navigate
    padding: 10px 0 10px 10px !important
  @media screen and (max-width: 499px)
    .min-m-t-10
      margin-top: 25px
</style>



// WEBPACK FOOTER //
// ActivitySummary.vue?465f4fd8